import React from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import { hasPermission, permissoesDaPersona } from "../utils/Utils";
import { ErrorPage403 } from "../pages/errors/ErrorPage403";

const ProtectedRoute = ({ user, permissions, permission, ...routeProps }) => {
	const chaves = permissoesDaPersona(user?.token_type);
	const requiredPermission = Array.isArray(permission) ? permission.map((chave) => chaves[chave]) : chaves[permission];

	if (!hasPermission(permissions, requiredPermission)) {
		return <ErrorPage403 />;
	}

	return <Route {...routeProps} />;
};

const mapStateToProps = ({ auth: { user, permissions } }) => ({ user, permissions });

export default connect(mapStateToProps)(ProtectedRoute);
